import type { TrustLayer } from '../data/trustLayers';
import { useI18n } from '../i18n/useI18n';

export function TrustLayerCard({ item }: { item: TrustLayer }) {
  const { t } = useI18n();
  const Icon = item.icon;

  return (
    <article className="trust-card">
      <div className="card-icon">
        <Icon aria-hidden="true" size={22} />
      </div>
      <div>
        <h3>{t(item.titleKey)}</h3>
        <p className="question">{t(item.questionKey)}</p>
        <p>{t(item.textKey)}</p>
      </div>
    </article>
  );
}
